// LimitedTimeModal 相关常量定义

// 24小时选项 - 根据图片固定数据
export const HOUR_OPTIONS = [
  { label: '00am', value: 0 },
  { label: '01am', value: 1 },
  { label: '02am', value: 2 },
  { label: '03am', value: 3 },
  { label: '04am', value: 4 },
  { label: '05am', value: 5 },
  { label: '06am', value: 6 },
  { label: '07am', value: 7 },
  { label: '08am', value: 8 },
  { label: '09am', value: 9 },
  { label: '10am', value: 10 },
  { label: '11am', value: 11 },
  { label: '12pm', value: 12 },
  { label: '01pm', value: 13 },
  { label: '02pm', value: 14 },
  { label: '03pm', value: 15 },
  { label: '04pm', value: 16 },
  { label: '05pm', value: 17 },
  { label: '06pm', value: 18 },
  { label: '07pm', value: 19 },
  { label: '08pm', value: 20 },
  { label: '09pm', value: 21 },
  { label: '10pm', value: 22 },
  { label: '11pm', value: 23 },
]

// 分钟选项：00, 10, 20, 30, 40, 50
export const MINUTE_OPTIONS = [0, 10, 20, 30, 40, 50].map(minute => ({
  label: minute.toString().padStart(2, '0'),
  value: minute,
}))

// Tab选项
export const TAB_OPTIONS = {
  HOUR: 'hour',
  MINUTE: 'minute',
} as const

export type TabType = typeof TAB_OPTIONS[keyof typeof TAB_OPTIONS]
